import { SelectedJobState } from '../reducers/jobs.reducer';
import { Component, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromJobs from '../reducers';
import * as jobActions from '../actions/jobs.actions';
import { Assignment } from '../models/assignment.model';
import { SelectedJobInfoComponent } from '../components/selected-job-info/selected-job-info.component';

@Component({
  selector: 'mj-view-job-info-page',
  template: `
    <mj-selected-job-info
      [jobState]="jobState$ | async"
      [categories]="categories$ | async"
      [jobTitleSuggestions]="jobTitleSuggestions$ | async"
      [jobAssignments]="jobAssignments$ | async"
      (saveJobState)="onJobSave($event)"
      (updateJobState)="onJobUpdate($event)"
    >
    </mj-selected-job-info>
  `,
})
export class ViewJobInfoPageComponent {
  jobState$: Observable<SelectedJobState>;
  categories$: Observable<any[]>;
  jobTitleSuggestions$: Observable<any[]>;
  jobAssignments$: Observable<Assignment[]>;
  @ViewChild(SelectedJobInfoComponent, { static: false })
  selectedJobInfoComponent: SelectedJobInfoComponent;

  constructor(public store: Store<fromJobs.State>) {
    this.jobState$ = this.store.select(fromJobs.getSelectedJob);
    this.categories$ = this.store.select(fromJobs.getCategories);
    this.jobTitleSuggestions$ = this.store.select(
      fromJobs.getJobTitleSuggestions
    );
    this.jobAssignments$ = this.store.select(fromJobs.getJobAssignments);
  }

  public onJobSave($event) {
    this.store.dispatch(
      new jobActions.SaveJob({ job: $event.job, listing: $event.listing })
    );
  }

  public onJobUpdate($event) {
    this.store.dispatch(
      new jobActions.SaveJob({ job: $event.job, listing: $event.listing })
    );
    // this.store.dispatch(new jobActions.UpdateJob({ job: $event.job, listing: $event.listing }));
  }
}
